import { render, staticRenderFns } from "./RewardPopup.vue?vue&type=template&id=09460111&"
import script from "./RewardPopup.vue?vue&type=script&lang=js&"
export * from "./RewardPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports